export const parseStringWithRegex = ({ string, regex }) => {
  const newString = string
    ?.split('')
    ?.filter((character) => character.match(regex));

  return newString?.join('');
};
